import {Pageable} from "../types/pagable.types";
import {RecordData} from "../types/records-table.types";

export const defaultPageableRecordData: Pageable<RecordData> = {
  content: [],
  number: 0,
  numberOfElements: 0,
  totalElements: 0,
  totalPages: 0,
  empty: true
};
